// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WaitingToJoinScreenNew_spaceContainer__MCyPi {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: radial-gradient(ellipse at center, #2d1b69 0%, #1a0d3d 40%, #0d0520 100%);
  /* No fade at start; fade only when hiding */
  transition: none;
  z-index: 2000;
}

.WaitingToJoinScreenNew_videoContainer__92ASA {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #000000;
  /* No fade at start; fade only when hiding */
  transition: none;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.WaitingToJoinScreenNew_video__MZMq7 {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
  transition: opacity 0.5s ease-in-out;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  backface-visibility: hidden;
  transform: translateZ(0);
  will-change: transform;
  display: block !important;
}

.WaitingToJoinScreenNew_hide__Wu4hQ {
  opacity: 0;
  pointer-events: none;
}

/* Apply fade-out only when transitioning to hide */
.WaitingToJoinScreenNew_videoContainer__92ASA.WaitingToJoinScreenNew_hide__Wu4hQ,
.WaitingToJoinScreenNew_spaceContainer__MCyPi.WaitingToJoinScreenNew_hide__Wu4hQ {
  transition: opacity 2s ease-out;
}

.WaitingToJoinScreenNew_stars__KPtag {
  position: absolute;
  width: 2px;
  height: 2px;
  background: #ffffff;
  border-radius: 50%;
  animation: WaitingToJoinScreenNew_fly__Q21\\+Z 3s linear infinite;
}

.WaitingToJoinScreenNew_stars__KPtag:nth-child(odd) {
  background: #ff6ec7;
  box-shadow: 0 0 10px #ff6ec7, 0 0 20px #ff6ec7;
  animation-duration: 2s;
  opacity: 0.8;
}

.WaitingToJoinScreenNew_stars__KPtag:nth-child(even) {
  background: #8a2be2;
  box-shadow: 0 0 8px #8a2be2, 0 0 15px #8a2be2;
  animation-duration: 2.5s;
  opacity: 0.9;
}

.WaitingToJoinScreenNew_stars__KPtag:nth-child(3n) {
  background: #4b0082;
  box-shadow: 0 0 6px #4b0082, 0 0 12px #4b0082;
  animation-duration: 4s;
  opacity: 0.6;
  width: 1px;
  height: 1px;
}

.WaitingToJoinScreenNew_stars__KPtag:nth-child(4n) {
  background: #da70d6;
  box-shadow: 0 0 12px #da70d6, 0 0 25px #da70d6;
  animation-duration: 1.5s;
  opacity: 0.9;
  width: 3px;
  height: 3px;
}

.WaitingToJoinScreenNew_stars__KPtag:nth-child(5n) {
  background: white;
  box-shadow: 0 0 15px rgba(255, 255, 255, 0.8), 0 0 30px rgba(255, 255, 255, 0.4);
  animation-duration: 2.2s;
  opacity: 1;
  width: 2px;
  height: 2px;
}

@keyframes WaitingToJoinScreenNew_fly__Q21\\+Z {
  0% {
    transform: translateZ(0) translateX(-50vw);
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    transform: translateZ(0) translateX(150vw);
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/screens/WaitingToJoinScreenNew.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,qFAAA;EAMA,4CAAA;EACA,gBAAA;EACA,aAAA;AAJF;;AAOA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,4CAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAJF;;AAOA;EACE,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,oCAAA;EACA,0CAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,sBAAA;EACA,yBAAA;AAJF;;AAOA;EACE,UAAA;EACA,oBAAA;AAJF;;AAOA,mDAAA;AACA;;EAEE,+BAAA;AAJF;;AAOA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,gEAAA;AAJF;;AAOA;EACE,mBAAA;EACA,8CAAA;EACA,sBAAA;EACA,YAAA;AAJF;;AAOA;EACE,mBAAA;EACA,6CAAA;EACA,wBAAA;EACA,YAAA;AAJF;;AAOA;EACE,mBAAA;EACA,6CAAA;EACA,sBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;AAJF;;AAOA;EACE,mBAAA;EACA,8CAAA;EACA,wBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;AAJF;;AAOA;EACE,iBAAA;EACA,gFAAA;EAEA,wBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;AALF;;AAQA;EACE;IACE,0CAAA;IACA,UAAA;EALF;EAOA;IACE,UAAA;EALF;EAOA;IACE,UAAA;EALF;EAOA;IACE,0CAAA;IACA,UAAA;EALF;AACF","sourcesContent":[".spaceContainer {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: radial-gradient(\n    ellipse at center,\n    #2d1b69 0%,\n    #1a0d3d 40%,\n    #0d0520 100%\n  );\n  /* No fade at start; fade only when hiding */\n  transition: none;\n  z-index: 2000;\n}\n\n.videoContainer {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: #000000;\n  /* No fade at start; fade only when hiding */\n  transition: none;\n  z-index: 2000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.video {\n  width: 100% !important;\n  height: 100% !important;\n  object-fit: cover !important;\n  transition: opacity 0.5s ease-in-out;\n  image-rendering: -webkit-optimize-contrast;\n  image-rendering: crisp-edges;\n  backface-visibility: hidden;\n  transform: translateZ(0);\n  will-change: transform;\n  display: block !important;\n}\n\n.hide {\n  opacity: 0;\n  pointer-events: none;\n}\n\n/* Apply fade-out only when transitioning to hide */\n.videoContainer.hide,\n.spaceContainer.hide {\n  transition: opacity 2s ease-out;\n}\n\n.stars {\n  position: absolute;\n  width: 2px;\n  height: 2px;\n  background: #ffffff;\n  border-radius: 50%;\n  animation: fly 3s linear infinite;\n}\n\n.stars:nth-child(odd) {\n  background: #ff6ec7;\n  box-shadow: 0 0 10px #ff6ec7, 0 0 20px #ff6ec7;\n  animation-duration: 2s;\n  opacity: 0.8;\n}\n\n.stars:nth-child(even) {\n  background: #8a2be2;\n  box-shadow: 0 0 8px #8a2be2, 0 0 15px #8a2be2;\n  animation-duration: 2.5s;\n  opacity: 0.9;\n}\n\n.stars:nth-child(3n) {\n  background: #4b0082;\n  box-shadow: 0 0 6px #4b0082, 0 0 12px #4b0082;\n  animation-duration: 4s;\n  opacity: 0.6;\n  width: 1px;\n  height: 1px;\n}\n\n.stars:nth-child(4n) {\n  background: #da70d6;\n  box-shadow: 0 0 12px #da70d6, 0 0 25px #da70d6;\n  animation-duration: 1.5s;\n  opacity: 0.9;\n  width: 3px;\n  height: 3px;\n}\n\n.stars:nth-child(5n) {\n  background: white;\n  box-shadow: 0 0 15px rgba(255, 255, 255, 0.8),\n    0 0 30px rgba(255, 255, 255, 0.4);\n  animation-duration: 2.2s;\n  opacity: 1;\n  width: 2px;\n  height: 2px;\n}\n\n@keyframes fly {\n  0% {\n    transform: translateZ(0) translateX(-50vw);\n    opacity: 0;\n  }\n  10% {\n    opacity: 1;\n  }\n  90% {\n    opacity: 1;\n  }\n  100% {\n    transform: translateZ(0) translateX(150vw);\n    opacity: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spaceContainer": `WaitingToJoinScreenNew_spaceContainer__MCyPi`,
	"videoContainer": `WaitingToJoinScreenNew_videoContainer__92ASA`,
	"video": `WaitingToJoinScreenNew_video__MZMq7`,
	"hide": `WaitingToJoinScreenNew_hide__Wu4hQ`,
	"stars": `WaitingToJoinScreenNew_stars__KPtag`,
	"fly": `WaitingToJoinScreenNew_fly__Q21+Z`
};
export default ___CSS_LOADER_EXPORT___;
